import { useNavigate, useParams } from "react-router-dom";

import Navbar from "../components/Navbar.jsx";
import Footer from "../components/Footer.jsx";
import ChatWindow from "../components/ChatWindow.jsx";
import { getStoredUserId } from "../lib/authStorage";

const ChatPage = () => {
  const { itemId, sellerId } = useParams();

  const navigate = useNavigate();

  const userId = getStoredUserId();

  const otherUserId = Number(sellerId);

  const roomKey = `${itemId}_${Math.min(
    userId,
    otherUserId
  )}_${Math.max(
    userId,
    otherUserId
  )}`;

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div
      className="
        flex
        h-[100dvh]
        min-h-0
        flex-col
        overflow-hidden
        bg-background
      "
    >
      {/* NAVBAR */}
      <div className="shrink-0">
        <Navbar />
      </div>

      {/* CHAT AREA */}
      <main
        className="
          flex
          min-h-0
          flex-1
          overflow-hidden
          justify-center
          bg-background
          md:px-4
          md:py-5
        "
      >
        <div
          className="
            flex
            min-h-0
            w-full
            flex-1
            flex-col
            overflow-hidden
            bg-card

            md:max-w-4xl
            md:rounded-2xl
            md:border
            md:border-border
            md:shadow-sm
          "
        >
          <ChatWindow
            key={roomKey}
            userId={userId}
            otherUserId={otherUserId}
            itemId={itemId}

            /*
             * Back button is rendered by ChatWindow
             * inside the pinned participant header.
             */
            onBack={handleBack}
          />
        </div>
      </main>

      {/* FOOTER - desktop only */}
      <div className="hidden shrink-0 md:block">
        <Footer />
      </div>
    </div>
  );
};

export default ChatPage;
